/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Fee display mode: 0 = no breakdown (final prices only), 1 = simple breakdown (taxes & fees combined), 2 = detailed breakdown (itemized)
 */
export type ShowIsBreakingOutFees =
    (typeof ShowIsBreakingOutFees)[keyof typeof ShowIsBreakingOutFees];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShowIsBreakingOutFees = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
} as const;
